import {NormalizerI} from './normalizer.i';
import {isString, isEmpty} from 'lodash';

const PHONE_CONST = {
    openPhone: '(',
    closePhone: ')',
    space: ' ',
    phoneStart: '+',
    empty: '',
    symbolsCount: 13
};

export class PhoneNormalizer implements NormalizerI {
    /**
     * Normalizer for phone type
     * @param value
     * @returns {string}
     * Input value example: 443644563433
     * Output value example: +44 (364) 456 34 33
     */
    normalize(value: string): string {
        if (!isString(value) || isEmpty(value)) {
            return '';
        }
        value = PHONE_CONST.phoneStart + value.replace(/[^0-9]/g, PHONE_CONST.empty);
        if (value.length > 3) {
            value = value.substring(0, 3) + PHONE_CONST.space + PHONE_CONST.openPhone + value.substring(3, value.length);
        }
        if (value.length > 8) {
            value = value.substring(0, 8) + PHONE_CONST.closePhone + PHONE_CONST.space + value.substring(8, value.length);
        }
        if (value.length > 13) {
            value = value.substring(0, 13) + PHONE_CONST.space + value.substring(13, value.length);
        }
        if (value.length > 16) {
            value = value.substring(0, 16) + PHONE_CONST.space + value.substring(16, value.length);
        }
        if (value.length > 19) {
            value = value.substring(0, 19);
        }

        return value;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/phone.normalizer.ts